import React from 'react'

import { ButtonIcon } from '../Button'
import { CloseIcon } from '../Icons'

export const DialogCloseButton = ({ onClick }: { onClick: () => void }) => (
  <ButtonIcon onClick={onClick}>
    <CloseIcon />
  </ButtonIcon>
)
